module.exports = __webpack_public_path__ + "static/media/arman.91cafc50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/arman.jpg
// module id = 735
// module chunks = 0